<template>
	<div class="page-login" style="height: 92vh; width: 100vw">
		<LoadingDialog ref="loading" />
		<div class="row">
			<div :style="{ backgroundColor: this.configVisualAgendamentoOnline.corSecundaria }"
				class="col-xs-3 col-md-3 col-sm-12  d-flex align-items-center">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<h1 class="text-brand-linx" title="Linx">Linx</h1>
							<h2 class="text-brand-product text-uppercase text-truncate" title="Microvix">
								Microvix
							</h2>
							<h3 class="text-uppercase text-white font-weight-bold" title="Agendamento Online">
								{{ nomeAplicacao }}
							</h3>
						</div>
					</div>
				</div>
			</div>
			<br />
			<div id="content-linx-login">
				<div class="col mobile-ajuste">
					<div class="row">
						<!-- Logo -->
						<div class="col-12 div-logo">
							<picture class="center-align logotipo text-center">
								<img v-bind:src="configVisualAgendamentoOnline.imagem" alt="Logo Linx"
								style="width: 230px; height: 230px; border-radius: 50%;" />
							</picture>
						</div>
						<div class="col-12">
							<div class="form-login">
								<!-- Alert de Erro -->
								<div class="alert alert-danger" style="padding: 2%" v-show="mensagemErro" id="div_aviso">
									<span id="msg">{{ mensagemErro }}</span>
									<a href="#" class="close" @click="atualizarMensagemErro(null)" title="close">x</a>
								</div>

								<!-- Box Empresa -->
								<transition name="slide-fade">
									<div v-if="true">
										<div class="form-group">
											<label>Empresa</label>
											<select class="form-control form-control-lg" v-model="empresaSelecionada">
												<option class="lmxta-buscaavancada-option-status" :value="null">Selecione
												</option>
												<option class="lmxta-buscaavancada-option-status"
													v-for="empresa in listPortais" :key="empresa.alias"
													:value="empresa.alias">
													{{ empresa.idEmpresa }} - {{ empresa.nomeEmpresa }}
												</option>
											</select>
										</div>
										<button type="button" style="width: 100%" class="btn btn-secondary"
											id="lmxta-login-btn-autenticar"
											@click="confirmaSelecaoEmpresa(empresaSelecionada)">
											Selecionar
										</button>
									</div>
								</transition>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as mutations from "../../plugins/mutations.nomes";
import "../../assets/assets_login/LinxBootstrap4/linx-bootstrap-v4.css";
import ApiService from "../../common/api.service";
import LoadingDialog from "@/components/Dialog/Loading";
import forms from "@/common/forms";
import maskCommon from '@/common/mask';

export default {
	name: "SelecionaEmpresa",
	components: { LoadingDialog },

	data() {
		return {
			empresaSelecionada: null,
			listPortais: [],
			mascaraCommon: maskCommon,
			mensagemErro: null,
			rules: forms.rules,
		};
	},

	async mounted() {
		this.empresasSelecao();
	},

	computed: {
		nomeAplicacao() {
			return process.env.VUE_APP_NOME_APLICACAO;
		},
    configVisualAgendamentoOnline() {
      return this.$store.state.configVisualAgendamentoOnline;
    },
	},

	methods: {

		async empresasSelecao() {
			try {
				const response = await ApiService.get(`agendamentoOnline/listarEmpresas/${this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias}`);
				this.listPortais = response.data;
				return this.listPortais;
			} catch (e) {
				this.$store.commit(mutations.EXIBIR_ERRO, e);
			}
			return this.listPortais;
		},

		confirmaSelecaoEmpresa: async function (alias) {
			var urlNovoAlias = window.location.href.replace(`${this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias}`,alias);
			this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias = alias;
			window.location.href = urlNovoAlias.replace("SelecionaEmpresa","Login");
		},

		atualizarMensagemErro: function (mensagem) {
			this.mensagemErro = mensagem;
		},
		async enviarEAguardarBackend(promises, texto) {
			return await this.$refs.loading.aguardarPromises(promises, texto);
		},
	},
};
</script>

<style scoped>
.centerDivStyle1 {
	margin-top: 2%;
	width: 15.5em;
	margin-left: auto;
	margin-right: auto;
}

.centerDivStyle2 {
	width: 9.5em;
	margin-left: auto;
	margin-right: auto;
}

.centerDivStyle3 {
	margin-top: 2%;
	width: 17.5em;
	margin-left: auto;
	margin-right: auto;
}

.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
	transform: translateX(10px);
	opacity: 0;
}

.page-login {
	background-color: #fff;
}

.page-login picture {
	margin-bottom: 50px;
}

.page-login .copyright {
	color: #fff;
	font-size: 0.8rem;
	position: absolute;
	bottom: 0px;
	left: 8px;
}

.page-login .link-support-web {
	position: absolute;
	right: 20px;
	bottom: 0;
	font-size: 2rem;
}

.link-support-mobile {
	position: absolute;
	right: 10px;
	top: 10px;
	font-size: 0.8rem;
	display: none;
}

.colum-height {
	height: 100vh;
}

.text-brand-linx {
	color: #ffb200;
	font-size: 2.625rem;
	font-weight: 300;
	margin-bottom: 0;
}

.text-brand-product {
	color: #fff;
	font-size: 3rem;
	font-weight: 300;
}

.page-login picture,
.form-login {
	padding-top: 30px;
	margin-bottom: 0px;
}

.form-login .control-label {
	font-size: 0.875rem;
	cursor: pointer;
	margin-top: 1.2rem;
}

.form-recover-password h1 {
	font-size: 1.875rem;
}

.fa-login svg {
	float: left;
	padding: 8px;
	font-size: 20px;
	width: 35px !important;
	height: 35px !important;
	text-align: center;
	text-decoration: none;
	border-radius: 50%;
	background: #ebebeb;
	color: black;
	margin-right: 5px;
}

.form-control {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: calc(2.25rem + 2px);
	padding: 0.375rem 0.75rem;
	font-size: 1rem;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

element.style {
	width: 100%;
}

.btn:not(:disabled):not(.disabled) {
	cursor: pointer;
}

.btn-secondary {
	color: #000;
	background-color: #ffb200;
}

.btn {
	font-family: "Dosis", sans-serif;
	font-weight: 500;
	font-size: 15px;
	text-transform: uppercase;
	box-sizing: border-box;
	border-radius: 0;
	border: 0;
	outline: 0;
	transition: background-color 0.2s ease;
}

.alert-danger {
	background-color: #f2dede;
	border-color: #ebccd1;
	color: #bc2c16;
}

.close {
	float: right;
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 1;
	color: #000;
	text-shadow: 0 1px 0 #fff;
	opacity: 0.5;
}

.two-button-class input {
	margin: 0 3%;
}

.two-button-class input:first-of-type {
	margin-left: 0;
}

.two-button-class input:last-of-type {
	margin-right: 0;
}

@media only screen and (max-width: 600px) {
	.mobile-ajuste {
		max-width: 60%;
		margin-left: 20%;
		margin-right: 20%
	}
}

@media only screen and (min-width: 601px) {
	.mobile-ajuste {
		max-width: 26%;
		margin-left: 37%;
		margin-right: 37%
	}
}
</style>
